import styled from "styled-components";

export const JoinUsBlockSection = styled("section")`
  position: relative;
  padding-top: 4rem;
  padding-bottom: 4rem;


  @media screen and (max-width: 1024px) {
    padding: 1rem 0 0rem;
    padding-bottom: 5rem;
  }
`;

export const ContentWrapper = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1140px;
  width: 100%;
  margin-top: -120px; /* Shift upward */

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;

    & > .left-column {
      padding: 0 10px;
      width: 100%;
      position: relative;
      min-height: 500px; 
    }
  }
`;


export const CoreTitle = styled("h6")`
  font-size: 40px;
  line-height: 1rem;
  padding: 0.8rem 0;
  color: #2159A6;
  font-family: "Gilroy Bold", sans-serif;


  @media screen and (max-width: 768px) {
    padding: 0.5rem;
  }
`;

export const MinPara = styled("p")`
  font-size: 22px;
  line-height: 1.8rem;
  color: #000000;
  font-family: "Gilroy Light", sans-serif;
  text-align: left;
  max-width: 950px;
  margin: 0 auto;
  padding: 15px 16px;

  @media screen and (max-width: 1024px) {
    max-width: 800px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const StyledImage = styled.img`
  position: relative;
  width: 100%;
  max-width: 100px;
  height: auto;

  
  @media (max-width: 768px) {
    position: relative;
    max-width: 80px;
    height: auto;
    padding: 2rem 0;
  }
`;

export const SemicircleRectangle = styled.div`
  position: relative;
  width: 220px;
  height: 220px;
  background-color: #2A3273;
  border-top-left-radius: 0;
  border-top-right-radius: 150px;
  border-bottom-right-radius: 150px;
  border-bottom-left-radius: 0;
  overflow: visible;

  &::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: 0px;
    width: 100px;
    height: 120px;
    background-color: #2159A6;
    border-top-left-radius: 0;
    border-top-right-radius: 90px;
    border-bottom-right-radius: 90px;
    border-bottom-left-radius: 0;
  }

  @media only screen and (max-width: 845px) {
    width: 100px;
    height: 110px;

    &::after {
      width: 60px;
      height: 60px;
      bottom: -20px;
    }
  }
`;

export const TopHalfSemicircleRectangle = styled.div`
   position: absolute;
  right: 0;
  bottom: -100px;
  width: 70px;
  height: 400px;
  background-color: #2159A6;
  border-top-left-radius: 90px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 90px;
  overflow: visible;

  @media only screen and (max-width: 1024px) {
    width: 40px;

    &::after {
      width: 90px;
      height: 60px;
      bottom: -15px;
      left: -20px;
    }
  }

  @media only screen and (max-width: 845px) {
    width: 70px;
    height: 200px;
    bottom: -100px;

    &::after {
      width: 90px;
      height: 60px;
      bottom: -15px;
      left: -20px;
    }
  }
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
`;

export const ActionButtonEmail = styled.a`
  padding: 10px 24px;
  font-size: 16px;
  color: #ffffff;
  background-color: #2159A6;
  border-radius: 20px;
  border: 2px solid #2159A6;
  text-decoration: none;
  font-family: "Gilroy Bold", sans-serif;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #FFFFFF;
    color: #2159A6;
  }
`;

export const ActionButtonCall = styled.a`
  padding: 10px 24px;
  font-size: 16px;
  color: #2159A6;
  background-color: #FFFFFF;
  border-radius: 20px;
  border: 2px solid #2159A6;
  text-decoration: none;
  font-family: "Gilroy Bold", sans-serif;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2159A6;
    color: #FFFFFF;
  }
`;